import React from "react";

const NotificationModal = ({ isOpen, type, message, onClose }) => {
  if (!isOpen) return null;
  const modalStyles = {
    success: {
      header: "bg-green-500 text-white",
      button: "bg-green-500 hover:bg-green-600",
    },
    error: {
      header: "bg-red-500 text-white",
      button: "bg-red-500 hover:bg-red-600",
    },
  };

  const { header, button } = modalStyles[type] || modalStyles.success;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="w-1/2 bg-white border rounded-lg shadow-lg text-center">
        <div className={`font-bold text-xl py-2 uppercase ${header}`}>
          {type === "success" ? "Success!" : "Error!"}
        </div>
        <div className="p-6 text-gray-800">
          <div className="mb-4">
            <img
              src={type === "success" ? "/assets/gif/msuccess.gif" : "/assets/gif/merror.gif"}
              alt={type === "success" ? "Success" : "Error"}
              className="max-w-[320px] max-h-[320px] mx-auto"
              style={{ animationPlayState: "running" }}
            />
          </div>
          <p className="text-lg font-medium">{message}</p>
          <button
            className={`mt-6 px-4 py-2 font-bold text-white rounded-lg ${button}`}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
